<template>
  <div class="make-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <div class="container">
        <button class="back-btn" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Question
        </button>
      </div>
    </div>

    <!-- Make Selection Section -->
    <section class="make-selection">
      <div class="container">
        <div class="make-content">
          <PageTitle title="Vehicle Make" />
          
          <div class="makes-grid">
            <button 
              v-for="make in availableMakes" 
              :key="make"
              :class="['make-button', { 'selected': selectedMake === make }]"
              @click="selectMake(make)"
            >
              {{ make }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import PageTitle from '@/components/PageTitle.vue'
import { submitDataAndLog } from '@/utils/localStorage'
import carInfoData from '@/data/car_info.json'

export default {
  name: 'MakePage',
  components: {
    AppHeader,
    AppFooter,
    PageTitle
  },
  data() {
    return {
      selectedMake: null,
      userQuoteData: null,
      availableMakes: [],
      carInfo: carInfoData,
      selectedYear: null
    }
  },
  mounted() {
    this.loadUserData()
    this.loadAvailableMakes()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          
          // 检查是否是添加车辆模式
          if (this.userQuoteData.adding_vehicle && this.userQuoteData.temp_vehicle) {
            this.selectedYear = this.userQuoteData.temp_vehicle.car_year
          } else {
            this.selectedYear = this.userQuoteData.car_year
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    loadAvailableMakes() {
      if (!this.selectedYear || !this.carInfo[this.selectedYear]) {
        console.error('No data available for selected year:', this.selectedYear)
        return
      }
      
      // 获取选定年份下的所有品牌
      const yearData = this.carInfo[this.selectedYear]
      this.availableMakes = Object.keys(yearData).sort()
      
      console.log('Available makes for', this.selectedYear, ':', this.availableMakes)
    },
    
    async selectMake(make) {
      this.selectedMake = make
      
      // 检查是否是添加车辆模式
      if (this.userQuoteData.adding_vehicle && this.userQuoteData.temp_vehicle) {
        // 添加车辆模式：更新临时车辆数据
        this.userQuoteData.temp_vehicle.car_make = make
        console.log('Selected make for additional vehicle:', make)
      } else {
        // 第一辆车模式：更新主车辆数据
        this.userQuoteData.car_make = make
        console.log('Selected make for primary vehicle:', make)
      }
      
      this.saveUserData()
      
      // 提交数据并记录页面提交事件
      await submitDataAndLog('make')
      
      // 跳转到车型选择页面
      this.$router.push('/model')
    },
    
    goBack() {
      this.$router.push('/year')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.make-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Navigation */
.navigation {
  padding: 1rem 0;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.back-btn:hover {
  color: #666;
}

/* Make Selection */
.make-selection {
  padding: 2rem 0 4rem;
  background: #fff;
  flex: 1;
}

.make-content {
  text-align: center;
  max-width: 1000px;
  margin: 0 auto;
}



.make-icon {
  margin: 1rem 0 2rem;
  color: #666;
}

.makes-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;
}

.make-button {
  padding: 1.2rem 1rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.make-button:hover {
  border-color: #007bff;
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
}

.make-button.selected {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

/* Responsive Design */
@media (max-width: 768px) {

  .makes-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.8rem;
    padding: 0 1rem;
  }

  .make-button {
    padding: 1rem 0.5rem;
    font-size: 0.8rem;
    min-height: 50px;
  }

  .make-selection {
    padding: 1.5rem 0 2rem;
  }
}

@media (max-width: 480px) {

  .makes-grid {
    gap: 0.6rem;
  }

  .make-button {
    padding: 0.8rem 0.3rem;
    font-size: 0.75rem;
    min-height: 45px;
  }

  .make-selection {
    padding: 1rem 0;
  }
}
</style>
